<template>
    <div class="settings">
        <input-media :label="$t('Poster')" v-model="video.poster" :storie-id="video.getStoryId()" @change="video.patch('poster')" />
        <input-media :label="$t('Subtitles')" v-model="video.subtitles" :storie-id="video.getStoryId()" @change="video.patch('subtitles')" />
        <input-select :items="endAction" v-model="video.end_action" :label="$t('End action')" :placeholder="$t('End action')" @change="video.patch('end_action')" />
        <Link_Small
            v-if="video.end_action === 'redirect'"
            :baseObject="video"
            :storyId="video.getStoryId()"
            :name="$t('Redirect link')"
        />
    </div>
</template>

<script>
import InputMedia from "@/modules/input/input-media";
import {video} from "@/class/video/video";
import Link_Small from "@/modules/links/Link_Small";
import InputSelect from "@/modules/input/input-select";
export default {
    name: "Video_Settings",
    components: {InputSelect, Link_Small, InputMedia},
    props:{
        video:{type:Object, default:new video()}
    },
    data(){
        return {
            endAction : [
                {text:'Nothing',value:'none'},
                {text:'Loop',value:'loop'},
                {text:'Back',value:'back'},
                {text:'Redirect',value:'redirect'},
            ],
        }
    }
}
</script>